.section,
.viewport {
  width: 100vw;
  height: 100svh;
  height: 100dvh;
  min-height: 0;
  margin: 0;
  padding: 0;
}

.section {
  overflow: hidden;
}

.viewport {
  position: relative;
  display: grid;
  place-items: center;
  overflow: hidden;
  isolation: isolate;
}

.background,
.backgroundPoster,
.overlay {
  position: absolute;
  inset: 0;
  width: 100vw;
  height: 100%;
  max-width: none;
}

.background,
.backgroundPoster {
  z-index: var(--z-media);
  object-fit: cover;
  object-position: center center;
}

.background {
  opacity: 0;
  transition: opacity var(--duration-normal) ease;
}

.backgroundPoster {
  opacity: 1;
  transition: opacity var(--duration-normal) ease;
}

.backgroundReady {
  opacity: 1;
}

.overlay {
  z-index: var(--z-overlay);
  background:
    linear-gradient(
      180deg,
      rgb(5 5 5 / 52%) 0%,
      rgb(5 5 5 / 42%) 48%,
      rgb(5 5 5 / 60%) 100%
    ),
    radial-gradient(circle at center, rgb(5 5 5 / 12%) 18%, rgb(5 5 5 / 58%) 100%);
  pointer-events: none;
}

.content {
  position: relative;
  z-index: var(--z-content);
  display: flex;
  width: min(100vw, 68rem);
  padding-inline: var(--page-margin);
  flex-direction: column;
  align-items: center;
  gap: var(--space-s);
  text-align: center;
  text-shadow: 0 2px 30px rgb(0 0 0 / 72%);
}

.title {
  font-size: var(--font-size-section);
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.02em;
  line-height: var(--line-height-section);
  text-wrap: balance;
}

.titleMobile {
  display: none;
}

.body {
  max-width: 48rem;
  color: var(--color-text-primary);
  line-height: 1.9;
}

@media (max-width: 47.9375rem) {
  .overlay {
    background:
      linear-gradient(
        180deg,
        rgb(5 5 5 / 58%) 0%,
        rgb(5 5 5 / 46%) 48%,
        rgb(5 5 5 / 66%) 100%
      ),
      radial-gradient(circle at center, rgb(5 5 5 / 16%) 16%, rgb(5 5 5 / 62%) 100%);
  }

  .content {
    gap: var(--space-xs);
  }

  .titleDesktop {
    display: none;
  }

  .titleMobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.12em;
    line-height: 1.15;
  }

  .titleMobile > span {
    white-space: nowrap;
  }

  .body {
    line-height: var(--line-height-body);
  }
}
